module.exports = __webpack_public_path__ + "img/stock0.8c137b9f.png";